import React from 'react'

function TypeTabContentTable({
  search,
  deviceGroupList,
  checkedControl,
  handleChecked,
  isAction,
}: any) {
  const listItems = search(deviceGroupList)?.map((item: any) => (
    <tr key={item.id}>
      <td>
        <input
          className='form-check-input'
          type='checkbox'
          value={item.id}
          checked={checkedControl(String(item.id))}
          onChange={(e) => handleChecked(e)}
        />
      </td>
      <td>
        <span>{item.thingName}</span>
      </td>
    </tr>
  ))

  if (isAction) {
    return (
      <div className='d-flex flex-column-fluid flex-center'>
        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
      </div>
    )
  }

  return (
    <table className='table table-striped gy-7 gs-7'>
      <thead>
        <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200  '>
          <th className='w-50px'>#</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>{listItems}</tbody>
    </table>
  )
}

export default TypeTabContentTable
